import EN_US from './en-us'
import EN_GB from './en-gb'
import EN_IN from './en-in'
import EN_AU from './en-au'
import FR from './fr'
import DE from './de'
import ES from './es'
import JA from './ja'
import KO from './ko'
import PT from './pt'
import ZH from './zh'
import CS from './cs'
import IT from './it'
import NL from './nl'
import NO from './no'
import PL from './pl'
import RU from './ru'
import TR from './tr'

export default {
    'en-us': EN_US,
    'en-au': EN_AU,
    'en-gb': EN_GB,
    'en-in': EN_IN,
    'fr': FR,
    'de': DE,
    'es': ES,
    'ja': JA,
    'ko': KO,
    'pt': PT,
    'zh': ZH,
    'cs': CS,
    'it': IT,
    'nl': NL,
    'no': NO,
    'pl': PL,
    'ru': RU,
    'tr': TR
}